export default __webpack_public_path__ + "static/media/JS Bank Cheque.f644caa3.png";